import { render, staticRenderFns } from "./IdentificationsPage.vue?vue&type=template&id=0fdc9cae&scoped=true"
import script from "./IdentificationsPage.vue?vue&type=script&lang=js"
export * from "./IdentificationsPage.vue?vue&type=script&lang=js"
import style0 from "./IdentificationsPage.vue?vue&type=style&index=0&id=0fdc9cae&prod&scoped=true&lang=css"
import style1 from "./IdentificationsPage.vue?vue&type=style&index=1&id=0fdc9cae&prod&lang=css"
import style2 from "./IdentificationsPage.vue?vue&type=style&index=2&id=0fdc9cae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdc9cae",
  null
  
)

export default component.exports